export default __webpack_public_path__ + "static/media/profile.fe89173d.jpeg";